/**
 * Stable no-op callbacks for use as default prop values.
 * Using inline arrow functions (e.g. () => false) as defaults creates new references
 * on every render, which can cause infinite loops when used in useEffect dependency arrays.
 */
export const NOOP = () => { /* no-op */ };
export const NOOP_FALSE = () => false;
export const NOOP_UNDEFINED = () => undefined;
